export default __webpack_public_path__ + "static/hero-balance-transfer-a2b5143981b3e0e2fe9777c37d5a98c9.webp";